import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const pageVariants = {
    initial: {
        opacity: 0,
        transition: { duration: 0.08 }, // Transição mais rápida
    },
    in: {
        opacity: 1,
    },
    out: {
        opacity: 0,
        transition: { duration: 0.08 }, // Transição mais rápida
    },
};

const PageTransition = ({ children, location }) => {
    return (
        <div style={{backgroundColor: "#ebe9e3", position: "absolute", zIndex: '-1', width: '100%', overflow: 'hidden'}}>
            <AnimatePresence mode="wait">
                <motion.div
                    key={location.pathname}
                    variants={pageVariants}
                    initial="initial"
                    animate="in"
                    exit="out"
                >
                    {children}
                </motion.div>
            </AnimatePresence>
        </div>
    );
};

export default PageTransition;